import { Injectable } from '@angular/core';
import { CurBaseService } from './firebase/curbase.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  actualPH;

  bps = [];
  vehicles = [];
  ups = {}

  bpsSub;
  vehSub;
  upsSub;


  constructor(private dataS: CurBaseService, private globalS: GlobalService) {
    this.globalS.getData().subscribe(data => {
      if (globalS.empresaId) {
        if (this.actualPH !== globalS.empresaId) {
          this.actualPH = globalS.empresaId
          this.inicializar();
        }
      }
    })
  }

  inicializar() {
    this.bpsSub?.unsubscribe();
    this.vehSub?.unsubscribe();
    this.upsSub?.unsubscribe();
    this.bpsSub = this.dataS.getCollectionFBIds(`/empresas/${this.globalS.empresaId}/bienesPrivados`).subscribe(bp=>{
      this.bps=bp;
    });
    this.vehSub = this.dataS.getCollectionFBIds(`/empresas/${this.globalS.empresaId}/vehiculosph`).subscribe(ve => {
      this.vehicles = ve;
    });
    this.upsSub = this.dataS.getCollectionFBIds(`/empresas/${this.globalS.empresaId}/unidadesPrivadas`).subscribe(up => {
      this.ups={}
      up.forEach(u=>{
        this.ups[u.id_reg]=u;
      })
    });
  }

  search(textIn:string){
    let text= textIn.toLowerCase()
    let results = [];
    this.bps.forEach(bp=>{
      let name=`${bp.uaNombre}-${bp.bpNombre} ${bp.id}`;
      let nameO = name.replace(/-/g," ")
      if(name.toLowerCase().includes(text)||nameO.toLowerCase().includes(text)||bp.id_reg.toLowerCase().includes(text)){
        results.push({
          title:name,
          type: "bp",
          data:bp
        });
      }
    })
    this.vehicles.forEach(veh => {
      if (veh.matricula.toLowerCase().includes(text) || veh.marca.toLowerCase().includes(text) || veh.modelo.toLowerCase().includes(text)) {
        results.push({
          title: `${veh.marca}-${veh.modelo} ${veh.matricula}`,
          type: "vehiculo",
          data: veh
        });
      }
    })
    return results
  }
}
